const STRING = {
  configuracoes: 'Settings',
  enderecos: 'Addresses',
  odhen_interface: 'Odhen Interface',
  perifericos_DNS: 'DNS Peripherals',
  porta_balanca: 'Scale port',
  cores: 'Colors',
  primary_color: 'Primary color',
  primary_light: 'Soft Primary color',
  primary_dark: 'Dark Primary color',
  header_color: 'Header color',
  categorie_color: 'Color of categories',
  categorie_font_color: 'Categories font color',
  cart_color: 'Background color of the cart',
  cart_font_color: 'Cart font color',
  consumidor: 'Consumer',
  tipo_consumidor: 'Consumer Type',
  codigo_loja: 'Store Code',
  codigo_filial: 'Branch Code',
  dispositivo: 'Device',
  digitos_NSU: 'Number of Digits for NSU (Ex. 13 or 20) empty for automatic',
  fechamento_automatico: 'Automatic closing at 00:00?',
  emitir_fechamento_dia: 'Send closing of the day',
  modalidade_entrega: 'Modality of delivery',
  drive_throught: 'Drive Throught',
  comer_aqui: 'Eat here',
  levar: 'Take',
  parametrizacao_impressora: 'Printer parameterization',
  modelo: 'Model',
  porta_impressora: 'Printer port',
  testar_impressora: 'Test printer',
  bematech_Mp_20: 'Bematech Mp-20',
  epson_tm_T88IIP: 'Epson Tm-T88IIP',
  bematech_Mp_2100: 'Bematech Mp-2100',
  bematech_Mp_4000: 'Bematech Mp-4000',
  sewoo_chile: 'Sewoo - Chile',
  IBM_4610_colombia: 'IBM-4610 - Colombia',
  bematech_MP_100_peru: 'Bematech MP-100 - Peru',
  daruma_DR600: 'Daruma DR600',
  epson_TM_U22A: 'Epson TM-U22A',
  daruma_DR700: 'Daruma DR700',
  epson_M244A: 'Epson M244A',
  zebra_Tlp_2844: 'Zebra Tlp 2844',
  bematech_MP_4200: 'Bematech MP-4200',
  epson_TM_T88V: 'Epson TM-T88V',
  epson_TM_T20: 'Epson TM-T20',
  sweda_SI_300S: 'Sweda SI-300S',
  elgin_I9: 'Elgin I9',
  epson_TM_T88IV_ethernet: 'Epson TM-T88IV Ethernet',
  elgin_kiosk_BKT681: 'Elgin Kiosk BKT681',
  bematech_MP_4200_compartilhada: 'Bematech MP-4200 - Shared',
  custom_TG2480H: 'Custom TG2480H',
  gpos700: 'GPOS700',
  poynt: 'Poynt',
  gerais: 'General',
  modo_TAP: 'TAP Mode?',
  modo_balanca: 'Toledo Prix 3 balance mode?',
  habilita_modo_slim: 'Enable Slim mode',
  habilita_leitura_cod: 'Enables barcode reading of products',
  habilita_acessibilidade: 'Enable accessibility mode',
  habilita_modo_edicao: 'Enable color editing mode',
  exibir_produtos_sem_foto: 'Display products without photo?',
  exibir_a_partir_de: 'Display "from" next to prices?',
  exibe_botao_continuar_comprando: 'Display "Continue Shopping" button in the cart?',
  cardapio_deve_expirar: 'Menu should expire every hour?',
  utiliza_pager: 'Use Pager?',
  altera_quantidade_adicionais: 'Can change the amount of additional items?',
  imprime_espelho_pedido: 'Print Order?',
  habilita_agruparnaimpressao: 'Enable collate on print',
  habilita_subgrupos: 'Enable Subgroups?',
  habilita_observacao_digitada: 'Enable Typed Observation?',
  exibe_itens_em_lista: 'Display promotional group items in list?',
  minimiza_grupo_quantidade_maxima: 'Minimize the group when reaching the maximum quantity?',
  taxa_servico_fixa: 'Use Fixed Service Rate?',
  diferenca_preco_minimo: 'Display minimum price difference?',
  pagamentos_homologacao: 'Homologation Payments? (Do not Activate in production)',
  imagens_customizaveis: 'Customizable Images (jpg, png)',
  configurar: 'Configure',
  usuario: 'User',
  senha: 'Password',
  entrar: 'Enter',
  cancelar: 'Cancel',
  version: 'Version',
  confirmar: 'Confirm',
  itens_pesaveis: 'Weighable items',
  cancelamento_TEF: 'Cancellation of TEF',
  NSU: 'NSU',
  nota_fiscal: 'Invoice',
  data: 'Date',
  valor: 'Value',
  debito: 'Debit',
  credito: 'Credit',
  pix_carteira_digital: 'PIX / Digital Wallet',
  voltar: 'Back',
  cancelar_TEF: 'Cancel TEF',
  siga_instrucoes_pinpad: 'Follow the instructions on the Pinpad',
  carrinho_vazio: 'Your cart is empty',
  total_caps: 'TOTAL',
  confirmar_pedido: 'Confirm Order',
  reverter: 'Revert',
  aplicar: 'Apply',
  esta_por_ai: 'Hello! Are you out there?',
  seu_pedido_te_espera: 'Your order awaits you',
  toque_para_voltar_ao_pedido: 'Tap to return to your order!',
  para_expirar: 'to expire',
  pedido_para: 'Your order is for:',
  viagem: 'To go',
  cadastrar_nova_senha: 'Register New Password',
  repita_a_senha: 'Repeat Password',
  aguarde: 'Wait',
  fechar: 'Close',
  alguma_observacao: 'Any remarks?',
  observacao_livre: 'Free observation',
  sem_observacao: 'No observation',
  login_consumidor: 'Consumer Login',
  login_sucesso: 'Login successful!',
  total_da_compra: 'Purchase Total:',
  saldo_familia: 'Family Balance',
  total_familia: 'Total Family',
  saldo_apos_pagamento: 'Balance after payment',
  saldo_cliente: 'Customer balance:',
  recarregar_saldo: 'Reload balance',
  confirmar_pagamento: 'Confirm Payment',
  sim: 'Yes',
  nao: 'No',
  enviar_por_e_mail: 'Send by E-mail',
  e_mail: 'E-mail',
  bloquear_desbloquear_produtos: 'Block / Unblock products',
  a_partir_de: 'From:',
  a_partir_de_gom: 'From ',
  recarga_de_saldo: 'Recharge Balance',
  valor_da_recarga: 'Recharge Value',
  CPF: 'CPF',
  familia_de_produtos: 'Family of Products',
  selecione_forma_pagamento: 'Select paymente method:',
  personalize_seu_combo: 'Customize your combo:',
  carrinho: 'Cart',
  comanda: 'Command:',
  remover: 'Remove',
  adicionar_nova_pesagem: 'Add new weighing',
  adicionar_mais_comandas: 'Add more commands',
  total_dois_pontos: 'TOTAL:',
  continuar_comprando: 'Continue Shopping',
  realizar_pagamento: 'Make Payment',
  digite_numero_comanda_ou_faca_leitura: 'Type your command number or read the barcode',
  digite_valor_deseja_pagar: 'Type the amount you want to pay',
  modo_acessibilidade: 'Accessibility Mode',
  digite_numero_comanda: 'Type the number of your command',
  identificacao_de: 'Identification of ',
  comanda_minusculo: 'command',
  comanda_maiusculo: 'Command',
  digitar_com_teclado: 'Type with keyboard',
  descricao: 'Description: ',
  confirmar_edicao: 'Confirm Editing',
  adicionar_ao_carrinho: 'Add to Cart',
  pagamento: 'Payment',
  informar_CPF_na_nota: 'Do you want to inform CPF/CNPJ in the invoice?',
  CNPJ: 'CNPJ',
  nao_informar: "Don't inform", // Confirmar impressão correta (detalhe aspas, ou na tradução trocar por 'Do not inform')
  CPF_CPNJ: 'CPF / CNPJ',
  todos_campos_obrigatorios: 'All fields are mandatory',
  data_informada_formato: 'The date must be informed in the format DDMMYYYY',
  valor_informado_casas_decimais: 'The value must be entered with a maximum of two decimal places',
  selecione_tipo_cancelamento: 'Select a cancellation type',
  atingiu_limite_categoria: 'You have reached the limit of items for this category.',
  escolha: 'Choose ',
  ate: 'until',
  opcao: ' option',
  opcoes: ' options',
  senhas_nao_sao_iguais: 'The passwords entered are not the same',
  senha_cadastrada_sucesso: 'Successfully Registered Password',
  nao_possivel_criar_nova_senha: 'It was not possible to create a new password for this user',
  houve_erro_ao_realizar_login: 'There was an error trying to login',
  erro_editar_consumidor_do_pedido: 'Error editing the consumer of the order',
  preencha_e_mail_corretamente: 'Fill in the e-mail field correctly or select another printing option',
  e_mail_digitado_nao_e_valido: 'The e-mail entered is not valid',
  valor_informado_deve_ser_maior_que_zero: 'The informed value must be greater than zero',
  selecione_familia_produtos: 'Select a family of products',
  recarga_realizada_com_sucesso: 'Your recharge was successful!',
  operacao_negada_autorizador_tente_novamente: 'Operation denied by the authorizer. <br><br> Check if the password was entered correctly, if the card has a balance/limit and try again',
  operacao_cancelada_operador_tente_novamente: 'Operation denied by the authorizer <br><br> Select the payment method and try again',
  nao_possivel_realizar_recarga_valor_estornado: 'It was not possible to carry out your recharge. <br><br> The amount paid has already been reversed.',
  qual_sabor_deseja: 'What flavor do you want?',
  posso_fazer_sugestao_tamanho: 'Can I make a size suggestion?',
  posso_fazer_sugestao_combo: 'Can I make a combo suggestion?',
  leia_o_QR_code: 'Read the QR Code',
  nao_ha_produto_padrao_pesagem_parametrizado: 'There is no standard product for parameterized weighing.',
  taxa_de_servico: 'Service fee: ',
  nome_dispositivo_obrigatorio: 'Device name is required!',
  endereco_interface_obrigatorio: 'The Odhen Interface address is mandatory!',
  endereco_perifericos_obrigatorio: 'The peripheral address is mandatory!',
  preenchimento_das_cores_obrigatorio: 'The filling of colors is mandatory!',
  cores_nao_podem_ser_iguais: 'The colors cannot be the same',
  parametros_aba_consumidor_faltando: 'There are parameters of the consumer tab that are missing',
  precisa_associar_totem_a_um_caixa: 'You need to associate the totem to a cashier',
  versao_interface: 'Version of Odhen Interface ',
  incompativel_com_o_TAA_necessario_versao: ' incompatible with the TAA. Version required ',
  ou_superior: ' or superior',
  tamanho_imagem_menor_que_5MB: 'Image size must be less than 5MB',
  interface_nao_encontrada_404: '404 - Odhen Interface not found, check the configuration files on the server.',
  sucesso_interface: 'Success Odhen Interface </br>',
  senha_invalida: 'Invalid password',
  realizar_login_outro_usuario: 'Login as another user?',
  deseja_realizar_logoff_usuario: 'Are you sure you want to log off the user?',
  logado_como: 'Logged in as',
  usuario_logado: 'User Logged in',
  escolha_forma_pagamento: 'Choose a paument method:',
  escolha_forma_pagamento_complementar: 'Choose the complementary payment method:',
  realize_pagamento_principal: 'Make the chosen main payment:',
  adicionar_taxa_servico: 'I would like to add the service fee in the amount of',
  CPF_CNPJ_invalido: 'Invalid CPF/CNPJ.',
  deseja_complementar: '<br><br>Do you want to complement ',
  com_outra_forma_pagamento: ' with another payment method?',
  voce_precisa_selecionar_algum: 'You need to select some ',
  terminal_de_auto_atendimento: 'TAA - Self-Service Terminal',
  deseja_limpar_carrinho: 'Are you sure you want to clear your cart?',
  certeza_que_deseja_remover: 'Are you sure you want to remove ',
  do_carrinho: ' from cart?',
  cliente_login_nao_e_o_mesmo_comanda: 'The customer who logged in is not the same one idemtified in the command---',
  valor_max_diario_familia: 'The maximum daily value of the product family "',
  foi_excedido_aspas: '" was exceeded',
  seu_saldo_familia_de_produtos: 'Your balance for the product family "',
  e_insuficiente: '" is insufficient',
  valor_max_diario_forma_pagamento: 'The maximum daily value of this payment method ',
  foi_excedido: ' was exceeded',
  saldo_insuficiente_completar_venda: 'Your balance is insufficient to complete this sale with the service fee',
  seu_saldo_esta_abaixo_de: 'Your balance is below ',
  seu_saldo: 'Your balance ',
  da_familia_de_produtos: 'from the product family ',
  das_familias_de_produtos: 'from families of products ',
  e: ' and ',
  esta_abaixo_de: ' is under ',
  nao_foi_possivel_configurar_pinpad: 'It was not possible to configure the PinPad to start the transaction. Check if the peripherals are running',
  operacao_negada_pelo_autorizador: 'Operation denied by the authorizer',
  problema_execucao_rotinas_pinpad: 'Problem executing some of the routines on the pinpad',
  cancelamento_TEF_finalizado_sucesso: 'TEF cancellation completed successfully',
  configuracoes_faltantes_404: '404 - There are missing configurations!',
  nao_foi_possivel_receber_XML: 'It was not possible to receive the invoice XML through the Odhen Interface',
  nao_foi_possivel_completar_venda: 'It was not possible to complete the sale. The amount paid has been reversed.',
  nao_possivel_completar_venda: 'It was not possible to complete the sale.',
  imagem_tela_de_espera: 'Waiting screen image',
  logo: 'Logo',
  produtos_sem_foto: 'Products without photo',
  instrucoes_pager: 'Instructions pager',
  instrucoes_balanca: 'Instructions Scale',
  instrucoes_TAP: 'TAP Instructions',
  instrucoes_da_maquininha: 'card machine instructions',
  instrucoes_da_impressora: 'Printer Instructions',
  erro_de_impressora: 'Printer Error',
  erro_ao_salvar_venda: 'Error saving sale',
  erro_de_pinpad: 'Error Pinpad',
  erro_pinpad_2: 'Error Pinpad 2',
  idiomas: 'Languages',
  idiomas_adicionais: 'Additional Languages',
  idioma_principal: 'Main Language',
  portugues: 'Portuguese',
  ingles: 'English',
  espanhol: 'Spanish',
  cupom_fiscal: 'Tax Coupon?',
  imprimir: 'Print',
  nao_preciso_do_cupom: "I don't need the coupon",
  importar_exportar_configuracoes: 'Import / Export Settings',
  definir_configuracoes_como_padrao: 'Set these settings as default',
  importar_configuracoes_servidor: 'Import server settings',
  remover_opcoes_impressao_envio_cupom_fiscal: 'Remove options for printing and sending the fiscal coupon?',
  problema_nao_identificado_TEF: 'There was an unidentified problem with the TEF',
  pagamento_nao_disponivel_para_este_usuario: 'This payment method is not available for this user. <br><br> Select another payment method.',
  nao_foi_possivel_configurar_pinpad_tente_novamente: 'It was not possible to configure the PinPad to start the transaction. Check if the peripheral is running <br><br> Any amount paid will be refunded <br><br> Try again',
  problema_execucao_rotinas_pinpad_tente_novamente: 'Problem executing some of the routines on the pinpad <br><br> Any amount paid will be refunded <br><br> Try again',
  problema_nao_identificado_TEF_tente_novamente: 'There was an unidentified problem with the TEF <br><br> Any amount paid will be refunded <br><br> Try again',
  utiliza_layout_alternativo: 'Use alternative layout?',
  proximo: 'Next',
  endereco_sitef: 'Sitef Address',
  configuracoes_salvas_para_caixa: 'There are saved settings for the cashier',
  importar_configuracoes: '<br> Do you want to import the settings?',
  deseja_importar_configuracoes_servidor: 'Do you want to import default server settings?',
  deseja_definir_configuracoes_atuais_padrão: 'Do you want to set the current settings of this TAA to default?',
  configuracoes_importadas_sucesso: 'Cashier settings have been successfully imported!',
  falha_importar_config_caixa: 'Unable to import cashier settings.',
  configuracao_definida_padrao: 'This TAA\'s settings have been set to default!',
  configuracao_padrao_importada: 'Default settings have been successfully imported!',
  falha_importar_config_padrao: 'Unable to load server settings.',
  utiliza_leitor_barras: 'Barcode reader?',
  insira_numero_comanda: 'Enter your order number:',
  insira_numero_pager: 'Enter pager number',
  por_favor_insira_comanda: 'Please enter your order number',
  escolha_um_grupo: 'What do you want?',
  concluir: 'Conclude',
  limpar: 'To clean',
  pesquisar: 'Search: ',
  nao_ha_itens: 'There are no cached items in the TAA. <br> To use the "Block/Unblock" function, you must have accessed the product menu. After loading the products this function will be available.',
  ultimo_fechamento_dia_sucesso: 'The last closing of the day was successfully completed. <br><br> This cashier is blocked until the next day.',
  fechamento_caixa_sucesso: 'The cashier closing was successfully completed.',
  este_e_ultimo_fechamento_dia: 'Is this the last close of the day?',
  caixa_bloqueado: 'Last closing of the day has already been performed for this totem. <br><br> The cashier is blocked.',
  nao_possui_acesso_suficiente: 'You don\'t have sufficient access to complete this operation.',
  permissoes_nao_cadastradas: 'The permissions for this user have not been registered. <br><br> Access the "Access Control TAA mobile" screen in Retail and register. <br><br> The TAA exclusively reads the permissions registered on that screen.',
  price_font_color: 'Price font color',
  preco_em_negrito: 'Enable bold price font',
  reimpressao_cupom_fiscal: 'Tax Coupon Reprint',
  visualizar: 'Visualize',
  data_dois_pontos: 'Date: ',
  verificar_conexao: 'Check Connection',
  pendente: 'Pending',
  processando: 'Processing...',
  falha: 'Failure',
  concluido: 'Concluded',
  atualizar_informações_caixa: 'Update Cashier Information',
  atualizar_recebimentos: 'Update Receipt Types',
  atualizar_imagens: 'Update Images',
  aplicar_configuracoes: 'Apply Settings',
  identificacao: 'Identification',
  informe_celular: 'Please enter your mobile number:',
  nao_q_informar: 'I don\'t want to inform',
  prox: 'Next',
  utiliza_layout_gom: 'Use Gom Layout',
  informe_cpf: 'Enter your CPF or CNPJ',
  cancelar_pedido: 'Cancel Order',
  voltar_cardapio: 'Return to Menu',
  boas_noticias: 'Good news!',
  voce_possui: 'You have ',
  utiliza_desconto: ' discount to use. Do you want to use this purchase?',
  desconto_aplicado: 'Discount applied successfully!',
  valor_compra: 'Purchase value: ',
  desconto: 'Discount: ',
  total_dois_pontos_simples: 'Total: ',
  agora_nao: 'Not now',
  aplicar_desconto: 'Apply discount',
  continuar: 'Continue',
  erro_valor_compra: 'Value entered higher than the total purchase value!',
  erro_valor_desconto: 'Value entered higher than the amount available for discount!',
  compra_concluida: 'Purchase completed.',
  aguarde_impressao: 'Wait for the order to print!',
  pedido_impresso: 'Order printed successfully!',
  falha_enviar_pedido: 'Failed to send order.',
  pedido: 'Order ',
  enviado_aguarde: 'sent. Wait...',
  aguardando_cupom: 'Waiting for tax receipt.',
  falha_cupom: 'Failed to receive tax receipt.',
  cupom_recebido: 'Tax coupon received successfully.',
  solicita_cancelamento: 'Requesting cancellation of sale number',
  venda: 'The sale',
  sera_cancelada: 'will be cancelled!',
  finalizando_compra: 'Finalizing your purchase. Wait...',
  imprimindo_cupom: 'Printing tax coupon. Wait...',
  cupom_impresso: 'Printed tax coupon!',
  timeOut_inatividade: 'Inactivity timeout (seconds)',
  timeOutInModal_inatividade: 'Timeout during inactivity modal (seconds)',
  keyboard_clear: 'Clear',
  keyboard_accept: 'Accept',
  posicione_o_codigo: 'Position the order',
  de_barras_comanda: 'barcode on the',
  no_leitor_abaixo: 'reader below',
  ou_digite_numero_comanda: 'or enter the order number:',
  keyboard_space: 'Space',
  confira_seu_pedido: 'Check your order',
  interface_sem_conexao: 'Odhen interface without connection to the database.',
  voltar_tela_inicial: 'Returning to home screen ',
  msg_pager: 'You can track your order via your cell phone, pointing the camera at the QRCODE on the side.',
  msg_qrcode: 'This QRCODE is also printed at the end of your tax coupon',
  voltar_agora: 'Back now',
  menor_zero: 'The value entered must be greater than 0',
  avanca_grupo_quantidade_maxima: 'Does the group advance automatically to reach the maximum amount?',
  demora_aguarde: 'This is taking longer than expected. \n Please wait.'
}

const getString = function (key) {
  return STRING[key]
}

export default {
  getString: getString
}
